/* Riora try-before-you-buy order box.
   One trial per cart: choosing an option replaces any trial line (and its gifts) already in the cart. */
(function () {
  /* Free gifts are added with a hidden form post instead of fetch. Shopify (and Meta, GA4, Klaviyo, Elevar)
     log an add-to-cart for every line added through fetch/XHR, so each order-box click counted as 4 add-to-carts.
     A form post into a hidden frame adds the same lines without firing those events.
     Safety net: if the gifts aren't in the cart after ~6s, they are added the normal way (events fire, gifts still land). */
  if (!window.rioraAddGiftsQuiet) {
    window.rioraAddGiftsQuiet = function (items) {
      items = (items || []).filter(function (it) { return it && it.id; });
      if (!items.length) return Promise.resolve();
      var json = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
      function cartHas() {
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var have = {};
            (cart.items || []).forEach(function (it) { have[String(it.variant_id)] = true; });
            return items.filter(function (it) { return !have[String(it.id)]; });
          });
      }
      var name = 'riora-gift-' + Date.now();
      var frame = document.createElement('iframe');
      frame.name = name;
      frame.title = 'Adding free gifts';
      frame.tabIndex = -1;
      frame.setAttribute('aria-hidden', 'true');
      frame.style.cssText = 'position:absolute;width:0;height:0;border:0;visibility:hidden';
      var form = document.createElement('form');
      form.method = 'POST';
      form.action = '/cart/add';
      form.target = name;
      form.style.display = 'none';
      function field(n, v) { var i = document.createElement('input'); i.type = 'hidden'; i.name = n; i.value = v; form.appendChild(i); }
      items.forEach(function (it, i) {
        field('items[' + i + '][id]', it.id);
        field('items[' + i + '][quantity]', it.quantity || 1);
        var p = it.properties || {};
        Object.keys(p).forEach(function (k) { field('items[' + i + '][properties][' + k + ']', p[k]); });
      });
      field('return_to', '/cart.js');
      document.body.appendChild(frame);
      document.body.appendChild(form);
      form.submit();
      function cleanup() { if (frame.parentNode) frame.parentNode.removeChild(frame); if (form.parentNode) form.parentNode.removeChild(form); }
      var tries = 0;
      function check() {
        return new Promise(function (r) { setTimeout(r, tries === 0 ? 500 : 400); })
          .then(cartHas)
          .then(function (missing) {
            if (!missing.length) return null;
            if (++tries < 12) return check();
            return missing;
          });
      }
      return check()
        .catch(function () { return items; })
        .then(function (missing) {
          cleanup();
          if (!missing || !missing.length) return;
          return fetch('/cart/add.js', { method: 'POST', headers: json, body: JSON.stringify({ items: missing }) })
            .then(function (res) { if (!res.ok) throw new Error('gift add failed ' + res.status); });
        });
    };
  }

  function init(root) {
    if (root.dataset.rtbReady) return;
    root.dataset.rtbReady = '1';
    var cta = root.querySelector('[data-rtb-cta]');
    var err = root.querySelector('[data-rtb-error]');
    var terms = root.querySelector('[data-rtb-terms]');
    if (!cta) return;
    function current() { return root.querySelector('input[type="radio"]:checked') || root.querySelector('input[type="radio"]'); }
    function sync() {
      var o = current();
      cta.textContent = (o && o.dataset.cta) ? o.dataset.cta : cta.dataset.default;
      if (terms) terms.textContent = (o && o.dataset.terms) || '';
      var note = root.querySelector('[data-rtb-note]');
      if (note) note.hidden = !(o && o.dataset.plan);
      var deal = root.querySelector('[data-rtb-deal]');
      if (deal) deal.hidden = !(o && o.dataset.plan); // deal box: Subscribe & Save only, like the note
    }
    root.addEventListener('change', sync);
    sync();

    cta.addEventListener('click', function () {
      var o = current();
      if (!o || cta.disabled) return;
      var vid = parseInt(o.dataset.variant, 10);
      var main = { id: vid, quantity: 1, properties: { _riora_offer: o.dataset.key || 'trial' } };
      if (o.dataset.plan) main.selling_plan = parseInt(o.dataset.plan, 10);
      var gifts = (o.dataset.gifts || '').split(',').map(function (g) { return parseInt(g, 10); }).filter(function (g) { return g > 0; });
      cta.disabled = true;
      if (err) err.hidden = true;
      var json = { 'Content-Type': 'application/json', 'Accept': 'application/json' };

      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .catch(function () { return { items: [] }; })
        .then(function (cart) {
          var items = cart.items || [];
          // Trial lines already in the cart, and the variants they sponsor gifts for.
          var trialVariants = {};
          var updates = {};
          items.forEach(function (it) {
            if (it.properties && it.properties._riora_offer) { trialVariants[String(it.variant_id)] = true; updates[it.key] = 0; }
          });
          items.forEach(function (it) {
            var sp = it.properties && it.properties._riora_gift_for;
            if (!sp) return;
            var sponsors = String(sp).split(',').filter(Boolean);
            var others = sponsors.filter(function (s) { return !trialVariants[s]; });
            if (sponsors.length && !others.length) updates[it.key] = 0;
          });
          // Also record the chosen offer as a cart attribute, so checkout (Checkout Blocks) can show offer-specific terms.
          var clear = fetch('/cart/update.js', { method: 'POST', headers: json, body: JSON.stringify({ updates: updates, attributes: { riora_offer: o.dataset.key || 'trial' } }) })
            .then(function (r) { return r.json(); });
          return clear.then(function (c) {
            var inCart = {};
            (c.items || []).forEach(function (it) { inCart[it.variant_id] = true; });
            var add = gifts.filter(function (g) { return !inCart[g]; }).map(function (g) {
              return { id: g, quantity: 1, properties: { _riora_gift_for: String(vid) } };
            });
            // Product first, then its gifts: gifts never sit in the cart without their product (the cart's
            // self-heal would remove them), and if the product can't be added no gifts are added either.
            return fetch('/cart/add.js', { method: 'POST', headers: json, body: JSON.stringify({ items: [main] }) })
              .then(function (res) {
                if (!res.ok) return res;
                return window.rioraAddGiftsQuiet(add).then(function () { return res; });
              });
          });
        })
        .then(function (res) {
          if (!res.ok) throw new Error('add failed ' + res.status);
          window.location.href = root.dataset.redirect === 'cart' ? '/cart' : '/checkout';
        })
        .catch(function (e) {
          console.error('Riora try-before-you-buy box:', e);
          cta.disabled = false;
          if (err) err.hidden = false;
        });
    });
  }
  function boot() { document.querySelectorAll('[data-rtb]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
